import { Navigate, useLocation } from "react-router-dom";
import { useAuth, defaultLandingForRole } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F4F5]">
        <div className="font-mono text-xs tracking-widest text-zinc-500 uppercase animate-pulse">
          Loading workspace…
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Force password change before anything else
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  // If role restrictions, redirect to user's landing page if mismatch
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={defaultLandingForRole(user.role)} replace />;
  }

  return children;
}